module.exports = __webpack_public_path__ + "static/media/lexus-provider.f37017e3.svg";